/**
 * BoardEmptyState — 게시판 미선택 또는 게시판이 없을 때 안내
 */
import React from 'react';
import { Trans } from '@lingui/macro';
import { LayoutList, RefreshCw } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { useCanManageBoards } from '../../context/WorkspaceSettingsContext';

interface Props {
  onRefresh: () => void;
}

const BoardEmptyState: React.FC<Props> = ({ onRefresh }) => {
  // 게시판 생성(+ 버튼)은 관리 권한자만 가능 → 비관리자에겐 '만들어보세요' 안내가 무의미
  const canManage = useCanManageBoards();
  return (
    <div className="flex-1 flex flex-col items-center justify-center gap-5 h-full px-6">
      {/* 아이콘 */}
      <div className="relative">
        <div className="size-20 rounded-2xl bg-gradient-to-br from-primary/15 to-primary/5 flex items-center justify-center">
          <LayoutList className="size-9 text-primary" strokeWidth={1.5} />
        </div>
        <div className="absolute -bottom-1 -right-1 size-6 rounded-full bg-background border-2 border-primary/20 flex items-center justify-center">
          <span className="text-meta-sm">📋</span>
        </div>
      </div>

      {/* 텍스트 */}
      <div className="text-center max-w-[280px]">
        <p className="text-base font-semibold text-foreground">
          <Trans>No boards</Trans>
        </p>
        <p className="text-sm text-muted-foreground mt-1.5 leading-relaxed">
          {canManage ? (
            <Trans>Create your first board with the <strong className="text-foreground/80">+</strong> button in the left sidebar</Trans>
          ) : (
            <Trans>Boards will appear here once an admin creates one</Trans>
          )}
        </p>
      </div>

      {/* 새로고침 */}
      <Button variant="outline" size="sm" onClick={onRefresh} className="mt-1">
        <RefreshCw className="size-3.5 mr-1.5" />
        <Trans>Refresh</Trans>
      </Button>
    </div>
  );
};

export default BoardEmptyState;
